import { render, staticRenderFns } from "./EditNumber.vue?vue&type=template&id=0a207d5b&"
import script from "./EditNumber.vue?vue&type=script&lang=js&"
export * from "./EditNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports